import PropTypes from "prop-types"
import { Component } from "react"
import { numberFormatter, percentageFormatter } from "helpers/formatters/numbers"
import { getFactorDisabled } from "helpers/factors"
import "./style.scss"

class Factor extends Component {
  onClick = () => {
    const { id, openFactorProfile } = this.props
    openFactorProfile(id)
  }

  render() {
    const { id, label, category, pnl, beta, performance, max, valueFormatter, displayBeta, displayReturn, isAggregated } = this.props

    const chartWidth = Math.abs(pnl) / max * 100

    let className, otherLabel

    if (pnl < 0) {
      className = "negative"
      otherLabel = "All Other Losing Factors"
    } else {
      className = "positive"
      otherLabel = "All Other Winning Factors"
    }

    const link = id === "other" || getFactorDisabled(category) || isAggregated
      ? label || otherLabel
      : <a onClick={this.onClick}>{label || otherLabel}</a>

    return <div className={`factor ${className}`}>
      <div className="display">{link}</div>
      <div className="value">
        <div className="barChart" style={{ width: `${chartWidth}%` }}>
          <span>{chartWidth > 26 && valueFormatter(pnl)}</span>
        </div>
        {chartWidth <= 26 && <div className="smallValue">{valueFormatter(pnl)}</div>}
      </div>
      {displayBeta && <div className="beta">{numberFormatter(beta)}</div>}
      {displayReturn && <div className="return">{percentageFormatter(performance)}</div>}
    </div>
  }
}

Factor.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  pnl: PropTypes.number.isRequired,
  beta: PropTypes.number,
  performance: PropTypes.number,
  max: PropTypes.number.isRequired,
  valueFormatter: PropTypes.func.isRequired,
  displayBeta: PropTypes.bool.isRequired,
  displayReturn: PropTypes.bool.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  category: PropTypes.string,
  isAggregated: PropTypes.bool,
}

export default Factor
